module.exports = __webpack_public_path__ + "static/img/guest5-big.00bb406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/pictures/guest5-big.jpg
// module id = fFNw
// module chunks = 0